import React from 'react';

import classes from './NgzPaymentResult.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { ErrorInfo } from '../../components/payment-result/ErrorInfo/ErrorInfo';
import { PaymentResultInfo } from './PaymentResultInfo/PaymentResultInfo';
import { useSignUpPaymentResult } from './hooks/useSignUpPaymentResult';
import { InfoContainer } from './components/InfoContainer/InfoContainer';
import { ResultTitle } from '../../components/payment-result/ResultTitle/ResultTitle';
import { collectSearchParams } from '../../utils/collectSearchParams/collectSearchParams';

const NgzPaymentResult = () => {
  const {
    isSuccess,
    params,
    paymentInfo,
    paymentResultType,
    isNonPaidSubscription,
    challengeId,
  } = useSignUpPaymentResult();

  // We should take the params from the URL before the '#!' part and move them after it
  // Stripe adding own params as a default query params, and we need to move them to the hash portion to be able angular router use them
  if (window.location.search.length) {
    collectSearchParams('payment-result');

    return null;
  }

  const renderPaymentInfo = () => {
    if (!isSuccess) {
      return <ErrorInfo retryPath={params.retryPath} />;
    } else if (!paymentInfo) {
      return null;
    } else if (paymentResultType) {
      return (
        <PaymentResultInfo
          paymentInfo={paymentInfo}
          consultationType={params.consultationType}
          paymentResultType={paymentResultType}
          isNonPaidSubscription={isNonPaidSubscription}
          challengeId={challengeId}
        />
      );
    }

    return (
      <InfoContainer>
        <ResultTitle
          isSuccessful={false}
          title="Something went wrong"
          description="Can't be processed"
        />
      </InfoContainer>
    );
  };

  return <div className={classes.container}>{renderPaymentInfo()}</div>;
};

angularizeWithProviders(NgzPaymentResult, 'ngzPaymentResult', {});
